import api from "./api";

// Retorno do simulador (endpoint /Simulador da core).
//
// Os campos valorLiquidoCliente/valorTaxaCliente são os antigos e continuam no
// payload por causa dos outros portais: valorTaxaCliente é PERCENTUAL, não
// reais, e valorLiquidoCliente carrega o bruto quando a simulação é reversa.
// A tela v2 usa os campos abertos abaixo, que não têm essa ambiguidade.
export interface Simulacao {
  // "DIRETA" (informou a venda) | "REVERSA" (informou o líquido desejado)
  modo: string;

  valorVenda: number;
  valorLiquido: number;

  percentual: number;
  valorPercentual: number;
  tarifaFixa: number;
  custoTotal: number;
  custoSobreLiquido: number;

  // PLANO | PLANO_GERAL | TARIFA | TARIFA_GERAL | PADRAO
  origemTaxa: string;
  origemDescricao: string | null;
  planoCliente: string | null;
  tarifaCliente: string | null;

  alerta: string | null;

  // compatibilidade
  valorLiquidoCliente: number;
  valorTaxaCliente: number;
}

// O que ESTE cliente pode simular, por tipo de venda. Vem tudo numa chamada
// porque a tela cruza as duas pontas: a forma de recebimento limita os tipos de
// venda (venda digitada só roda crédito) e o tipo de venda limita bandeiras e
// parcelas. Débito, por exemplo, só existe nas bandeiras de débito (Visa
// Electron, Maestro, Elo, Diners, Banescard), nunca em Visa/Master.
export interface ProdutoOpcao {
  id: number;
  nome: string;
  bandeirasCredito: { id: number; nome: string }[];
  bandeirasDebito: { id: number; nome: string }[];
  maxParcelas: number;
  temPix: boolean;
  temBoleto: boolean;
  temBolepix: boolean;
}

export interface OpcoesSimulacao {
  plano: string | null;
  tarifa: string | null;
  produtos: ProdutoOpcao[];
}

export interface ParametrosSimulacao {
  idCliente: number;
  idProduto: number;
  idBandeira: number;
  idForma: string;
  valor: number;
  // true = "quero receber este valor, quanto preciso vender?"
  reversa: boolean;
}

export default class SimulatorAPI {
  static getSimulation = async (
    idCliente: number,
    idVenda: number,
    idBandeira: number,
    idforma: string,
    valor: number,
    vlReverse: boolean
  ) => {
    const response = await api.get(
      `/Simulador?idCliente=${idCliente}&idProduto=${idVenda}&idBandeira=${idBandeira}&idforma=${idforma}&valor=${valor}&vlreverse=${vlReverse}`
    );
    return response.data;
  };

  static opcoes = async (idCliente: number): Promise<OpcoesSimulacao> => {
    const response = await api.get(`/Simulador/opcoes?idCliente=${idCliente}`);
    return response.data as OpcoesSimulacao;
  };

  // Mesma rota, retorno tipado com a conta aberta.
  static simular = async (p: ParametrosSimulacao): Promise<Simulacao> => {
    const response = await api.get(
      `/Simulador?idCliente=${p.idCliente}&idProduto=${p.idProduto}&idBandeira=${p.idBandeira}` +
        `&idforma=${encodeURIComponent(p.idForma)}&valor=${p.valor}&vlreverse=${p.reversa}`
    );
    return response.data as Simulacao;
  };
}
